/**
 * The portal Work board's row open and the dialog's record load. A row opens the occurrence dialog by its key
 * (`workTaskOccurrenceKey`); the dialog reads the Work task read for that key. A row with no key opens nothing.
 */
import { inject, Injector } from '@angular/core';
import { ActivityEntityName, WorkTaskScheduleCommandId, WorkTaskScheduleRow, WorkTaskScheduleTask } from '@jms/model';
import { EntityDataServiceRaw } from '@workbuddy/services/entities';
import { EntityOperationRecordLoader } from '@workbuddy/services/entities/entity.manifest.surface';
import { EntityInspectors } from '@workbuddy/ui/v2/blocks/entity.inspector';
import { firstValueFrom } from 'rxjs';
import { workTaskOccurrenceModel } from '../../presentation/work.task.occurrence';
import { parseWorkTaskOccurrenceKey, workTaskOccurrenceKey } from '../../presentation/work.task.occurrence.key';

/** Portal row click (`itemInteraction.navigate`, an injection context): the clicked occurrence's dialog, read-only. */
export async function openWorkTaskOccurrence(item: WorkTaskScheduleRow): Promise<void> {

  const key = workTaskOccurrenceKey(item);
  if (!key) return;
  const injector = inject(Injector);

  await injector.get(EntityInspectors).open({
    operation: 'preview',
    entity: ActivityEntityName.WorkTaskSchedule,
    id: key,
  });
}

/** The dialog's record: the Work task read for the key, shaped as the dialog's model; null for a key it did not mint. */
export const loadWorkTaskOccurrence: EntityOperationRecordLoader<WorkTaskScheduleRow> = async ({ id, injector }) => {

  const request = parseWorkTaskOccurrenceKey(id);
  if (!request) return null;
  const task = await firstValueFrom(injector.get(EntityDataServiceRaw).executeCommand<WorkTaskScheduleTask>(ActivityEntityName.WorkTaskSchedule, WorkTaskScheduleCommandId.Task, request));

  return task?.row ? workTaskOccurrenceModel(task, id) : null;
};
